import { render, staticRenderFns } from "./prescription_data_white.vue?vue&type=template&id=f47feeb8&scoped=true&v-once=true"
import script from "./prescription_data_white.vue?vue&type=script&lang=js"
export * from "./prescription_data_white.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47feeb8",
  null
  
)

export default component.exports